var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarView = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14310_445455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 0.666992L5.33203 2.66699M10.6654 0.666992V2.66699M11.332 5.33366H4.66536M7.73203 14.667H8.26536C10.5056 14.667 11.6257 14.667 12.4813 14.231C13.234 13.8475 13.8459 13.2356 14.2294 12.483C14.6654 11.6273 14.6654 10.5072 14.6654 8.26699V7.73366C14.6654 5.49345 14.6654 4.37334 14.2294 3.5177C13.8459 2.76505 13.234 2.15313 12.4813 1.76963C11.6257 1.33366 10.5056 1.33366 8.26537 1.33366H7.73203C5.49182 1.33366 4.37172 1.33366 3.51607 1.76963C2.76342 2.15313 2.1515 2.76505 1.76801 3.5177C1.33203 4.37334 1.33203 5.49345 1.33203 7.73366V8.26699C1.33203 10.5072 1.33203 11.6273 1.76801 12.483C2.1515 13.2356 2.76342 13.8475 3.51607 14.231C4.37172 14.667 5.49182 14.667 7.73203 14.667Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14310_445455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarView);
export default ForwardRef;